import { useAuthentication } from '@zenbusiness/application-commons-authentication';

import { SECTION_ORDER, SECTION_ORDER_HAS_AUTH_ACCOUNT } from '../constants/sections';

/**
 * Custom hook to determine the checkout section sequence.
 *
 * @returns {Array} The sequence of sections for the checkout process.
 */
export function useCheckoutSections() {
  const { authenticated } = useAuthentication();

  if (authenticated) {
    return SECTION_ORDER_HAS_AUTH_ACCOUNT;
  }

  return SECTION_ORDER;
}
